import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmDashboardConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { EmDashboardService } from './api/emDashboard.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmDashboardApiModule {
    public static forRoot(configurationFactory: () => EmDashboardConfiguration): ModuleWithProviders<EmDashboardApiModule> {
        return {
            ngModule: EmDashboardApiModule,
            providers: [ { provide: EmDashboardConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmDashboardApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmDashboardApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
